export default class Tabs {
    constructor(htmlNode) {
        let elements = htmlNode.querySelectorAll('[data-tabs]');

        if ( elements.length < 1 ) {
            return;
        }

        let title = document.title;

        elements.forEach((element) => {
            let list = element.querySelector('[data-tabs-list]'),
            triggers = element.querySelectorAll( '[data-tabs-target]' ),
            targets = element.querySelectorAll( '[data-tabs-id]' );

            let initTab = [...triggers].filter((t) => {
                return t.classList.contains('active') == true;
            });

            let initTabID = initTab[0].getAttribute( 'data-tabs-target' );

            list.addEventListener( 'click', ( e ) => {
                if ( window.innerWidth < 768 ) {
                    e.preventDefault();
                    list.classList.toggle( 'tabs-opened' );
                }
            } );

            triggers.forEach((trigger) => {
                trigger.addEventListener('click', (e) => {
                    let tabID = trigger.getAttribute( 'data-tabs-target' ),
                    target = [...targets].filter((t) => {
                        return t.getAttribute('data-tabs-id') == tabID;
                    });

                    if ( target.length > 0 ) {
                        triggers.forEach((el) => {
                            el.classList.remove('active');
                        });

                        targets.forEach((el) => {
                            el.classList.remove('active');
                        });

                        target.forEach((el) => {
                            el.classList.add('active');
                        });

                        trigger.classList.add('active');

                        let changeEvent = new CustomEvent('change', target);
                        element.dispatchEvent(changeEvent);

                        let refreshEvent = new CustomEvent('refresh-view', target);
                        htmlNode.dispatchEvent(refreshEvent);

                        history.pushState( { target: tabID }, title, trigger.getAttribute( 'data-href' ) );
                    } else {
                        window.location.href = tabID;
                    }
                });
            });

            window.addEventListener( 'popstate', (e) => {
                let tabID = initTabID;

                if ( e.state !== null ) {
                    tabID = e.state.target;
                }

                let target = [...targets].filter((t) => {
                    return t.getAttribute('data-tabs-id') == tabID;
                });

                let trigger = [...triggers].filter((t) => {
                    return t.getAttribute('data-tabs-target') == tabID;
                });

                if ( target.length > 0 ) {
                    triggers.forEach((el) => {
                        el.classList.remove('active');
                    });

                    targets.forEach((el) => {
                        el.classList.remove('active');
                    });

                    target.forEach((el) => {
                        el.classList.add('active');
                    });

                    trigger.classList.add('active');

                    let changeEvent = new CustomEvent('change', target);
                    element.dispatchEvent(changeEvent);

                    let refreshEvent = new CustomEvent('refresh-view', target);
                    htmlNode.dispatchEvent(refreshEvent);
                }
            } );
        } );
    }
}